export const userIcon = [
  "24 24",
  `
  <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M17,21v-2
	c0-2.209-1.791-4-4-4H5c-2.209,0-4,1.791-4,4v2 M9,3c2.209,0,4,1.791,4,4s-1.791,4-4,4S5,9.209,5,7S6.791,3,9,3z M23,21v-2
	c-0.002-1.822-1.234-3.414-3-3.87 M16,3.13c2.141,0.548,3.431,2.727,2.883,4.867C18.521,9.413,17.416,10.518,16,10.88"/>

  `,
];
